module.exports = __webpack_public_path__ + "img/sfsLogo.4ebcd10c.jpg";